// Constants
import { ROUTES } from "@/src/constants/Routes";
// Mantine
import { Flex } from "@mantine/core";
// Next JS
import { useRouter } from "next/router";
import React from "react";

interface HeaderProps {
  hasRedirect?: boolean;
  children?: React.ReactNode;
  minHeight?: string;
  onToolbarButtonClick?: () => void;
}

const Header = ({hasRedirect = false, minHeight = '48px', onToolbarButtonClick, children}: HeaderProps ) => {
  const router = useRouter();

  const navigateToHome = () => {
    if (onToolbarButtonClick) {
      onToolbarButtonClick();
    }
    if (hasRedirect) {
      router.push(ROUTES.USER_DASHBOARD);
    }
  }

	return <>
	  <Flex mih={minHeight} miw="100%" bg="#FFFFFF" direction="row" align="center" justify="space-between" pl={22} pr={22}>
      <Flex gap={8} style={{cursor: 'pointer'}} onClick={navigateToHome}>
        <img src="/images/logo.svg" alt="logo"/>
        <img src="/images/my-page.svg" alt="my-page"/>
      </Flex>
      <Flex direction="row" gap={20}>
        {children}
      </Flex>
    </Flex>
	</>
}

export default Header
